import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { reset, setSelfPayIntake as updateSelfPayIntake } from '../redux/userSlice';
import { reset as insuranceReset } from '../redux/insuranceSlice';
import { reset as stripeReset } from '../redux/stripeSlice';
import { reset as portalReset } from '../redux/portalSlice';
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

const SelfPayLanding = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(reset());
        dispatch(insuranceReset());
        dispatch(stripeReset());
        dispatch(portalReset());
        dispatch(updateSelfPayIntake(true));
        setPageAndDeferNavigate(dispatch, '/concern', navigate);

    }, [dispatch, navigate]);

    return null;
};

export default SelfPayLanding;
